import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { LL_H_C, LL_V_L } from '../../components/Layouts/index.js';
import { TS_AppTools } from '../../components/TS_AppTools/index.js';
import { __stringify, exists, sortArray } from '@nu-art/ts-common';
import { _className } from '../../utils/tools.js';
import './ATS_AppConfigEditor.scss';
import { TS_JSONViewer } from '../../components/TS_JSONViewer/TS_JSONViewer.js';
import { TS_TextArea } from '../../components/TS_Input/index.js';
import { Button } from '../../components/Button/Button.js';
import { AppConfigKey_FE, ModuleFE_AppConfig } from '../../index.js';
export class ATS_AppConfigEditor extends ComponentSync {
    //######################### Static #########################
    static Screen = (props) => ({
        key: 'app-config-editor',
        renderer: () => _jsx(ATS_AppConfigEditor, { ...props }),
        name: 'App Config Editor',
        group: 'Editors',
        modulesToAwait: [ModuleFE_AppConfig],
    });
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        const allConfigs = !!nextProps.appConfigFilter
            ? ModuleFE_AppConfig.cache.filter(nextProps.appConfigFilter)
            : ModuleFE_AppConfig.cache.allMutable();
        state.configs ??= sortArray(allConfigs, config => config.key);
        if (!state.selectedKey && state.configs.length) {
            const configKey = new AppConfigKey_FE(state.configs[0].key);
            state.selectedKey ??= configKey.key;
            state.dataString = this.resolveDataString(configKey.get());
        }
        return state;
    }
    //######################### Logic #########################
    getConfigKey(key) {
        if (!key)
            return;
        return new AppConfigKey_FE(key);
    }
    resolveDataString(data) {
        return __stringify({ data: data }, true);
    }
    selectConfig = (config) => {
        const configKey = this.getConfigKey(config.key);
        const dataString = this.resolveDataString(config.data);
        this.setState({ selectedKey: configKey?.key, dataString });
    };
    saveData = async (data) => {
        const selectedKey = this.state.selectedKey;
        if (!selectedKey)
            return;
        const configKey = new AppConfigKey_FE(selectedKey);
        await configKey.set(data.data);
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { id: 'ats__app-config-editor', children: [TS_AppTools.renderPageHeader('App Config Editor'), _jsxs(LL_H_C, { className: 'app-config-editor__main', children: [this.render_AppConfigList(), this.render_Editor()] })] });
    }
    render_AppConfigList = () => {
        const selectedKey = this.state.selectedKey;
        return _jsx(LL_V_L, { className: 'app-config-editor__config-list', children: this.state.configs.map(config => {
                const className = _className('app-config-editor__config-list__config', config.key === selectedKey && 'selected');
                return _jsx("div", { className: className, onClick: () => this.selectConfig(config), children: config.key }, config._id);
            }) });
    };
    //######################### Render - Editor #########################
    render_Editor = () => {
        const selectedKey = this.state.selectedKey;
        const config = this.state.configs.find(config => config.key === selectedKey);
        if (!config)
            return;
        return _jsxs(LL_V_L, { className: 'app-config-editor__editor', children: [_jsx("div", { className: 'app-config-editor__editor__title', children: config.key }), _jsxs(LL_H_C, { className: 'app-config-editor__editor__views', children: [_jsx(TS_JSONViewer, { item: config }), this.render_Editor_DataEditor()] })] });
    };
    render_Editor_DataEditor = () => {
        const dataString = this.state.dataString;
        let dataObject = undefined;
        let error = undefined;
        if (!dataString)
            return;
        try {
            dataObject = JSON.parse(dataString);
        }
        catch (e) {
            error = e;
        }
        return _jsxs(LL_V_L, { className: 'app-config-editor__editors', children: [_jsx(TS_TextArea, { type: 'text', value: dataString, onChange: value => this.setState({ dataString: value }) }), exists(dataObject) && _jsx(TS_JSONViewer, { item: dataObject }), exists(error) && _jsx("p", { className: 'app-config-editor__error', children: error.message }), _jsx(Button, { disabled: exists(error), onClick: () => this.saveData(dataObject), children: "Save Data" })] });
    };
}
//# sourceMappingURL=ATS_AppConfigEditor.js.map